import { MessageInfo } from "../../../../types/info";
import { ExectiveLatestAction } from "../../../../types/actions";
import { GetExecutiveResportResponseV3 } from "../../../../../../server/types/request/report/exective";

export type State = {
	loading: boolean;
	info: MessageInfo;
} & GetExecutiveResportResponseV3;

export const initState: State = {
	goalSalesVolume: undefined,
	data: [],
	loading: true,
	info: {
		isSuccess: true,
		message: "",
	},
};

export const reducer = (state: State, action: ExectiveLatestAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				...action.payload,
			};
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
